import { render, staticRenderFns } from "./RepeaterCustomFieldComponent.vue?vue&type=template&id=23c1ad87"
import script from "./RepeaterCustomFieldComponent.vue?vue&type=script&lang=js"
export * from "./RepeaterCustomFieldComponent.vue?vue&type=script&lang=js"
import style0 from "./RepeaterCustomFieldComponent.vue?vue&type=style&index=0&id=23c1ad87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports